export default "__VITE_PUBLIC_ASSET__61839d41__"